import { ProgressRing } from '@/components/ProgressRing'
import type { CountdownPhase } from '@/domain/workout'
import { cx } from '@/lib/cx'
import { mmss } from '@/lib/format'
import type { PhaseRuntime } from './usePhaseRunner'
import styles from './workout.module.css'

interface CountdownViewProps {
  phase: CountdownPhase
  runtime: PhaseRuntime
}

/** Descansos y transiciones: solo el reloj y una instrucción corta. */
export function CountdownView({ phase, runtime }: CountdownViewProps) {
  return (
    <div className={cx(styles.work, styles.workCentered)}>
      <ProgressRing progress={runtime.progress} overall={runtime.overall} resting />

      <div className={styles.status}>
        <div className={cx(styles.statusLabel, styles.statusResting)}>{phase.tag}</div>
        <div className={styles.statusName}>{phase.name}</div>
        {phase.briefing && <div className={styles.statusNext}>{phase.briefing}</div>}
      </div>

      <div className={cx(styles.clockBig, runtime.remaining <= 5 && styles.clockWarning)}>
        {mmss(runtime.remaining)}
      </div>
    </div>
  )
}
